var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogFile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.437,
    height: 19.578,
    viewBox: "0 0 16.437 19.578",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "log-file",
    transform: "translate(-46.1 -6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M102.723,38.217a.541.541,0,0,1-.54.54H90.24a.541.541,0,0,1-.54-.54V20.84a.541.541,0,0,1,.54-.54h9.01v3.473h3.473Z",
    transform: "translate(-41.893 -13.74)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M85.51,6H76.5a1.1,1.1,0,0,0-1.1,1.1V24.477a1.1,1.1,0,0,0,1.1,1.1H88.443a1.1,1.1,0,0,0,1.1-1.1V10.037Zm3.473,18.477a.541.541,0,0,1-.54.54H76.5a.541.541,0,0,1-.54-.54V7.1a.541.541,0,0,1,.54-.54h9.01v3.473h3.473Z",
    transform: "translate(-28.153)",
    fill: "#2b669f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M333.6,6v4.037h4.033Z",
    transform: "translate(-276.243)",
    fill: "#084272"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33",
    transform: "translate(46.1 17.132)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M62.537,296.584H46.1v-5.591a.692.692,0,0,1,.693-.693H61.84a.692.692,0,0,1,.693.693v5.591Z",
    transform: "translate(-46.1 -290.3)",
    fill: "#084272"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M61.39,450.8v.764l1.147-.764Zm-14.143,0v.764L46.1,450.8Z",
    transform: "translate(-46.1 -444.516)",
    fill: "#1a252d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M64.1,308.4H79.124v4.875H64.1Z",
    transform: "translate(-63.395 -307.691)",
    fill: "#f26522"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_34",
    "data-name": "Group 34",
    transform: "translate(48.782 8.318)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M121.793,65.725h-6.93a.262.262,0,0,1,0-.525h6.93a.262.262,0,1,1,0,.525Zm0,1.253h-6.93a.262.262,0,1,1,0-.525h6.93a.262.262,0,1,1,0,.525Zm3.661,1.249H114.862a.262.262,0,0,1,0-.525h10.591a.262.262,0,1,1,0,.525Zm0,1.253H114.862a.262.262,0,0,1,0-.525h10.591a.262.262,0,1,1,0,.525Zm0,1.253H114.862a.262.262,0,1,1,0-.525h10.591a.262.262,0,1,1,0,.525Zm0,1.249H114.862a.262.262,0,1,1,0-.525h10.591a.262.262,0,1,1,0,.525Zm0,1.253H114.862a.262.262,0,0,1,0-.525h10.591a.262.262,0,1,1,0,.525Z",
    transform: "translate(-114.6 -65.2)",
    fill: "#2b669f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35",
    transform: "translate(52.012 18.71)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M197.633,333.047H197.1V330.6h.533Zm.478-.865a.893.893,0,0,1,.215-.623.768.768,0,0,1,.6-.239.776.776,0,0,1,.607.239.893.893,0,0,1,.215.623v.031a.886.886,0,0,1-.215.623.885.885,0,0,1-1.21,0,.893.893,0,0,1-.215-.623Zm.529.035a.734.734,0,0,0,.067.337.27.27,0,0,0,.45,0,.717.717,0,0,0,.067-.333v-.039a.739.739,0,0,0-.067-.333.238.238,0,0,0-.227-.125.232.232,0,0,0-.223.125.728.728,0,0,0-.067.333Zm1.5-.016a1.081,1.081,0,0,1,.172-.638.571.571,0,0,1,.489-.243.422.422,0,0,1,.235.063.6.6,0,0,1,.176.18l.035-.211h.466v1.68a.636.636,0,0,1-.231.521.994.994,0,0,1-.634.184,1.2,1.2,0,0,1-.278-.035,1.38,1.38,0,0,1-.278-.1l.09-.392a1.037,1.037,0,0,0,.219.074,1.1,1.1,0,0,0,.239.023.4.4,0,0,0,.251-.067.258.258,0,0,0,.082-.211V332.9a.478.478,0,0,1-.168.141.483.483,0,0,1-.215.047.574.574,0,0,1-.486-.231,1.013,1.013,0,0,1-.172-.615V332.2Zm.529.031a.712.712,0,0,0,.059.321.208.208,0,0,0,.2.114.348.348,0,0,0,.149-.027.254.254,0,0,0,.1-.078v-.713a.294.294,0,0,0-.1-.094.33.33,0,0,0-.145-.031.213.213,0,0,0-.2.129.786.786,0,0,0-.063.345Z",
    transform: "translate(-197.1 -330.6)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogFile);
export default __webpack_public_path__ + "static/media/log-file.e3f3cb913a2b039a4a7a22687de59001.svg";
export { ForwardRef as ReactComponent };